import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from '../../enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from '../../enums/personalInformationFieldNames';
import { LegalEntityFormValues } from '../../types/legalEntityFormValues';
import { legalEntityValidationRules } from '../validation-rules/optim/legalEntityValidationRules';

const legalEntityFormConfig = createFormConfig<LegalEntityFormValues>(
  legalEntityValidationRules as ValidationRules<keyof LegalEntityFormValues>,
  {
    [PersonalInformationFieldNames.Civility]:
      'Mr',
    [PersonalInformationFieldNames.Nationality]: 'FR',
    [PersonalInformationFieldNames.BirthCountry]: 'FR',
    [AddressFormFieldNames.Country]: 'FR',
    [PersonalInformationFieldNames.Nationality]:
      'FR',
    [NaturalPersonFormFieldNames.TaxResidenceCountryId]: 'FR'
  }
);

export { legalEntityFormConfig };
